import type { ComponentProps } from 'react';

import { Avatar } from '@change/ds-core-ui';
import { MenuIcon } from '@change/ds-icons/MenuIcon';
import { SearchIcon } from '@change/ds-icons/SearchIcon';
import { HeaderLayout, HeaderLayoutButton } from '@change/ds-layout';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { Dropdown } from './components/Dropdown';
import { Logo } from './components/Logo';
import { SAPButton } from './components/SAPButton';
import { useHeader } from './hooks/useHeader';

export const Header: React.FC<ComponentProps<'div'>> = (props) => {
	const {
		data: { navLinks, showAvatarMenu, showMenu },
	} = useHeader();
	const { translate } = useI18n();

	const getUserActionSlot = () => {
		if (showAvatarMenu) {
			// Show placeholder Avatar before isLoaded to prevent layout shift
			return showMenu ? <Dropdown /> : <Avatar size="small" alt="" className="h-8 w-8" />;
		}

		return (
			<HeaderLayoutButton
				href="/login_or_join?user_flow=nav"
				data-qa="header-login-link"
				qaAttribute="header-login-link"
			>
				<Translate value="fe.components.header.log_in" />
			</HeaderLayoutButton>
		);
	};

	return (
		<HeaderLayout
			logo={<Logo />}
			navLinks={navLinks}
			sapButton={<SAPButton data-qa="header-sap-button" />}
			searchButton={
				showMenu && (
					<HeaderLayoutButton
						aria-label={translate('fe.components.header.search')}
						href="/search"
						qaAttribute="header-search-link"
						data-qa="header-search-link"
						iconOnly
						leadingIcon={<SearchIcon />}
					/>
				)
			}
			userActionSlot={getUserActionSlot()}
			mobileMenu={
				// Show ghost button before isLoaded to prevent layout shift
				showMenu ? (
					<Dropdown mobile />
				) : (
					<HeaderLayoutButton as="div" aria-label="" iconOnly leadingIcon={<MenuIcon />} />
				)
			}
			{...props}
		/>
	);
};
